




























































































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class HelpItemDevice extends Vue {
  show = true
}
